module.exports = __webpack_public_path__ + "img/iconKuCunChaXun.2777f361.svg";